export const GOOGLE_ANALYTICS_UA = 'UA-168595917-1'


// WEBPACK FOOTER //
// ./src/Constants/ga.js